import React from 'react'
import {useParams} from "react-router";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import AsyncBlock from "../../components/forms/AsyncBlock";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import PageContainer from "../../components/layout/PageContainer";
import PageSection from "../../components/layout/PageSection";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageTitle from "../../components/layout/PageTitle";
import useFetch2 from "../../hooks/useFetch2";
import RiskForm from "./RiskForm";

const RiskEdit = () => {

  const navigate = useNavigate()

  const {id} = useParams()
  const {data, loading, fetchData, error} = useFetch2(Apis.PROD + '/riesgo/' + id, {});

  const onUpdate = (risk) => {
    risk.id = id;
    axios.put(Apis.PROD + '/riesgo/update/' + id, risk)
      .then(res => {
        successToast("Riesgo actualizado correctamente")
        navigate('/riesgos')
      })
      .catch(err => {
        errorToast(err.response.data.message, 6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Riesgos' onClick={() => navigate('/riesgos')}/>
        <PageTitle title={'Riesgo'}/>
      </PageSection>

      <PageSection>
        <AsyncBlock loading={loading} error={error}>
          <RiskForm value={data} onSubmit={(risk) => onUpdate(risk)}/>
        </AsyncBlock>

      </PageSection>
    </PageContainer>
  )
}

export default RiskEdit;
